import { checkboxClasses, formControlLabelClasses, type Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const FormCheckboxStyle: StyleExtend<Theme> = {
  alignItems: 'start',
  gap: '0.75rem',
  userSelect: 'none',
  width: 'fit-content',

  [`&.${formControlLabelClasses.root}`]: {
    margin: '0',
  },

  ':has(input[readonly])': {
    opacity: '0.5',

    [`.${checkboxClasses.root}`]: {
      opacity: '1',
    },
  },
};

export const FormCheckboxCheckboxStyle: StyleExtend<Theme> = {
  fontSize: '1.25rem',

  [`&.${checkboxClasses.root}`]: {
    padding: '0',
  },

  svg: {
    fontSize: 'inherit',
  },
};
